import { onReady } from '../../shared/utils/helpers';
import Base from '../../components/base/base';
import CookieConsent from '../../components/cookie-consent/cookie-consent';
import Header from '../../components/header/header';
import BeforeAfterSlider from '../../components/before-after-slider/before-after-slider';
import BuyerIntakeForm from '../../components/buyer-intake-form/buyer-intake-form';
import HeroTriangleOverlay from '../../components/hero-triangle-overlay/hero-triangle-overlay';
import ClearPath from '../../components/clear-path/clear-path';
import CollectionData from '../../components/collection-data/collection-data';
import './home.scss';

interface HomePageOptions {
  debug?: boolean;
  [key: string]: any;
}

class HomePage extends Base {
  private header: Header;
  private beforeAfterSlider: BeforeAfterSlider;
  private heroTriangleOverlay: HeroTriangleOverlay;
  private clearPath: ClearPath;
  private collectionData: CollectionData | null = null;

  constructor(options: HomePageOptions = {}) {
    // Pass debug option to Base class
    super(options.debug || false);
    this.debug = options.debug || false;
    
    // Initialize header with same debug setting for consistent logging
    this.header = new Header({ debug: this.debug });
    this.beforeAfterSlider = new BeforeAfterSlider({
      selector: '.ba-slider',  // or a more specific selector
      initialPosition: 33,
      debug: this.debug
    });
    this.heroTriangleOverlay = new HeroTriangleOverlay({
      debug: this.debug
    });
    this.clearPath = new ClearPath({
      debug: this.debug
    });
    
    this.init();
  }

  init(): void {
    this.log('HomePage initialized');

    // Cookie consent gate. Webflow holds the Meta Pixel until this grants.
    try {
      new CookieConsent({ debug: this.debug });
      this.log('CookieConsent initialized');
    } catch (e) {
      this.log('CookieConsent init failed or skipped', e);
    }

    try {
      this.collectionData = new CollectionData({ debug: this.debug });
      this.log('CollectionData initialized');
    } catch (e) {
      this.log('CollectionData init failed or skipped', e);
    }

    // Initialize Buyer Intake Form
    try {
      new BuyerIntakeForm({ debug: this.debug });
      this.log('BuyerIntakeForm initialized');
    } catch (e) {
      this.log('BuyerIntakeForm init failed or skipped', e);
    }
  }
}

onReady(() => {
  // You can enable debug mode by passing { debug: true }
  new HomePage({ debug: true });
});

export default HomePage;